<div class="container" [formGroup]="inputForm">
  <div class="row">
    <div class="col col-12">
      <mat-form-field class="w-100">
        <mat-label>Contacts limit</mat-label>
        <input matInput type="number" formControlName="limit" />
      </mat-form-field>
    </div>
  </div>
</div>
